// REACT
import React from 'react';

// CUSTOM COMPONENTS
import StyledSelectField from '../StyledSelectField';
import { HideWidth } from '../HideWidth';
import { StyledMediaQ } from '../StyledMediaQ';
import StyledLink from '../StyledLink';
import TextButton from '../Button/TextButton';
import { StyledDivider } from '../StyledDivider';
import OuterContainerSC from './OuterContainerSC';
import InnerContainerSC from './InnerContainerSC';

import App from '../../containers/App';

// VENOR COMPONENTS
import Close from 'material-ui/svg-icons/navigation/close';
import withRouter from 'react-router-dom/withRouter';
/*

Props:
    • mediaQ1
    • handleListSelectionChange
    • menuItems
    • onClickClose
    • serviceCategoryValues
*/

class SearchFilter extends React.Component { 
    render() {
        return (
            <OuterContainerSC>
                <div style={styles.fullWidthPadding}>
                    <InnerContainerSC mediaQ1={this.props.mediaQ1}>
                        <StyledSelectField
                            //style={selectFieldStyles}
                            width={200}
                            multiple={true}
                            hintText="Browse by Category"
                            value={this.props.serviceCategoryValues}
                            onChange={this.props.handleListSelectionChange}
                        >
                            {this.props.menuItems}
                        </StyledSelectField>
                        <HideWidth width={this.props.mediaQ1}>
                            <StyledDivider color='rgba(0, 0, 0, 0.3)' marginLeft={20}/>
                        </HideWidth>
                        <StyledMediaQ
                            defaultStyles={'margin-left: 30px;'}
                            break1_maxWidth={this.props.mediaQ1}
                            styles_break1={'margin-left: 5px; margin-top: 20px;'}
                        >
                            <StyledLink
                                color={'#4AC4D1'}
                                letterSpacing={0.08}
                                to={'/expert-search'} 
                                // marginLeft= {30}
                                fontSize={12}
                            >
                                Search&nbsp;Experts
                            </StyledLink>
                        </StyledMediaQ>
                    </InnerContainerSC>
                    
                    <TextButton
                        onClick={this.props.onClickClose}
                    >
                        <Close color={'gray'}/>
                    </TextButton>
                </div>
            </OuterContainerSC>
        );
    }
}

const styles = {
    fullWidthPadding: {
        alignItems: 'start', 
        display: 'flex', 
        flexDirection: 'row', 
        justifyContent: 'space-between',
        width: '98%'
    }
}

export default withRouter(SearchFilter);


// WEBPACK FOOTER //
// ./src/js/components/Search/SearchFilter.jsx